module.exports = __webpack_public_path__ + "phoneHolder.png";